var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: _vm.currentFolder.id == -1 ? "新增文件夹" : "修改文件夹",
        visible: _vm.dialogVisible,
        width: "1200px",
        "show-close": true,
        "append-to-body": true,
        "destroy-on-close": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "folderName", label: "文件夹名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "520px" },
                    model: {
                      value: _vm.form.folderName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "folderName", $$v)
                      },
                      expression: "form.folderName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "folderRuleType", label: "文件夹条件" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "0" },
                      model: {
                        value: _vm.form.folderRuleType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "folderRuleType", $$v)
                        },
                        expression: "form.folderRuleType",
                      },
                    },
                    [_vm._v("满足所有条件")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.form.folderRuleType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "folderRuleType", $$v)
                        },
                        expression: "form.folderRuleType",
                      },
                    },
                    [_vm._v("满足任意一条")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "folderRuleList" },
                [
                  _vm._l(_vm.form.folderRuleList, function (item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "0",
                              prop:
                                "folderRuleList." +
                                index +
                                ".conditionFieldType",
                              rules: _vm.rules.conditionFieldType,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: item.conditionFieldType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "conditionFieldType", $$v)
                                  },
                                  expression: "item.conditionFieldType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "主题", value: "0" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "发件人", value: "1" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "收件人", value: "2" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "正文", value: "3" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "0",
                              prop:
                                "folderRuleList." +
                                index +
                                ".conditionOperatorType",
                              rules: _vm.rules.conditionOperatorType,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: item.conditionOperatorType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "conditionOperatorType", $$v)
                                  },
                                  expression: "item.conditionOperatorType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "包含", value: "0" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "等于", value: "1" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "0",
                              prop:
                                "folderRuleList." + index + ".conditionValue",
                              rules: _vm.rules.conditionValue,
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: item.conditionValue,
                                callback: function ($$v) {
                                  _vm.$set(item, "conditionValue", $$v)
                                },
                                expression: "item.conditionValue",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            index + 1 == _vm.form.folderRuleList.length
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small" },
                                    on: { click: _vm.add },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-circle-plus-outline",
                                      staticStyle: { color: "#2395f3" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.del(index)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-remove-outline",
                                  staticStyle: { color: "red" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm.form.folderRuleList.length == 0
                    ? _c(
                        "div",
                        { staticClass: "init-rule" },
                        [
                          _c("el-button", {
                            attrs: {
                              size: "small",
                              icon: "el-icon-circle-plus-outline",
                              circle: "",
                            },
                            on: { click: _vm.add },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }